import { render, staticRenderFns } from "./validate-address.component.vue?vue&type=template&id=87d3e81c&"
import script from "./validate-address.component.vue?vue&type=script&lang=ts&"
export * from "./validate-address.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports